import React from "react";
import "../assets/css/certificate.css";

const CertificateView = ({ data }) => {
  if (!data) return null;

  return (
    <div className="certificate-wrapper">
      <div className="certificate">

        {/* HEADER */}
        <div className="cert-header">
          <img
            src="./logo.png"
            alt="ICA"
            className="cert-logo"
          />

          <h1>Institute of Computer & Accounting</h1>
          <p className="verify-title">Certificate Verification Result</p>
        </div>

        {/* STATUS */}
        <div className="valid-badge">✔ Verified & Authentic</div>

        {/* BODY */}
        <div className="cert-body">

          <div className="row">
            <span>Student Name</span>
            <b>{data.name}</b>
          </div>

          <div className="row">
            <span>Course</span>
            <b>{data.course}</b>
          </div>

          <div className="row">
            <span>Grade</span>
            <b>{data.grade}</b>
          </div>

          <div className="row">
            <span>Certificate Number</span>
            <b>{data.certificate_no}</b>
          </div>

          <div className="row">
            <span>Release Number</span>
            <b>{data.release_no}</b>
          </div>

          <div className="row">
            <span>Date Issued</span>
            <b>{data.date}</b>
          </div>

        </div>

        {/* FOOTER */}
        <div className="cert-footer">
          This certificate has been verified from ICA official records.
        </div>

      </div>
    </div>
  );
};

export default CertificateView;